import styled from "styled-components";

export const ViewProjectFeeContainer = styled.div`
  margin: 0px 0px 24px 0px;
`;
